<section class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'etude_dossier'"></app-stepper-component>
    <div class="simulation__group">
        <div>
            <h1 class="page-title page-title--primary">
                {{ 'documentselection.header.title' | i18n }}
            </h1>
            <section class="waiting-page">
                <div class="waiting-page__modal-content">
                    <p class="iconblock--waiting2 waiting-page__iconblock--waiting"></p>
                    <p class="waiting-page__message">
                        {{ 'documentselection.waiting.description' | i18n }}
                    </p>
                </div>

                <div class="simulation__group consents__warning">
                    <p class="consents__information consents__warningText hide-mobile">
                        <em class="icon--info consents__warning--iconPadding"></em>
                        {{ 'documentselection.waiting.info' | i18n }}
                    </p>
                    <p class="consents__information warning warning--light hide show-mobile">
                        {{ 'documentselection.waiting.info' | i18n }}
                    </p>
                </div>
            </section>

            <div class="grid-12 grid-mobile-4 waiting-page--button">
                <button type="button" data-tag-commander [appTagCommander]="'tagCo.waiting.validate.button'" class="button button--primary button--next centered" routerLink="/espace-client/tableau-de-bord">
                    {{ 'documentselection.button.dashboard' | i18n }}
                </button>
            </div>
        </div>
    </div>
</section>
<app-steps-adhesion-modal [currentStepId]="'etude_dossier'"></app-steps-adhesion-modal>
